<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getProductCategories()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-apps
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Product Categories
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getTaxRates()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-chart-box-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Tax Rates
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getWebhooksList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-multiple
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Webhooks
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-credit-card-check
                </v-icon>
              </v-list-item-icon>
              Payments
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getProductCategories()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-apps
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Product Categories
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getTaxRates()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-chart-box-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Tax Rates
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getWebhooksList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-multiple
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Webhooks
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <div>
      <product-categories v-if="showProductCategories" />
      <tax-rates v-if="showTaxRates" />
      <webhooks-list v-if="showWebhooksList" />
    </div>
  </v-container>
</template>
<script>
  import TaxRates from 'src/views/dashboard/payments/taxrates/TaxRates.vue';
  import ProductCategoryList from 'src/views/dashboard/payments/product/ProductCategoryList.vue';
  import WebhooksList from 'src/views/dashboard/payments/webhooks/WebhooksList.vue';

  export default {
    name: 'Payments',
    components: {
      'tax-rates': TaxRates,
      'product-categories': ProductCategoryList,
      'webhooks-list': WebhooksList,
    },
    data: () => ({
      selectedItem: -1,
      showTaxRates: false,
      showProductCategories: true,
      showWebhooksList: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getTaxRates () {
        this.showProductCategories = false;
        this.showWebhooksList = false;
        this.showTaxRates = true;
      },
      getProductCategories () {
        this.showTaxRates = false;
        this.showWebhooksList = false;
        this.showProductCategories = true;
      },
      getWebhooksList () {
        this.showProductCategories = false;
        this.showTaxRates = false;
        this.showWebhooksList = true;
      },
    },
  };
</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
</style>
